import { frontendURL } from '../../../helper/URLHelper';
import RedirectingPage from './pages/RedirectingPage.vue';

const meta = { permissions: ['administrator', 'agent'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/redirecting'),
    alias: [
      frontendURL('accounts/:accountId/redirecionando'),
      frontendURL('accounts/:accountId/crm/redirecting'),
    ],
    name: 'lais_redirecting',
    component: RedirectingPage,
    meta,
  },
];
